import { z } from "zod"

import { apiEnvironmentKeys } from "../../taxonomy.js"

export const ApiHealthResponseSchema = z.object({
  ok: z.boolean(),
  service: z.string(),
  context: z.string(),
})

export type ApiHealthResponse = z.infer<typeof ApiHealthResponseSchema>

export const ApiReadyResponseSchema = z.object({
  ok: z.boolean(),
  environment: z.enum(apiEnvironmentKeys),
})

export type ApiReadyResponse = z.infer<typeof ApiReadyResponseSchema>
